module.exports = __webpack_public_path__ + "img/kuang_down.9c44ada1.png";